import React from "react";

export default function Item({ className, labelClassName, label, htmlFor="", children, style, ...rest }: any) {
  return (
    <div className={className} style={style}>
      {label && <label className={labelClassName} htmlFor={htmlFor}>{label}</label>}

      {typeof children === "function"
        ? children({ field: rest })
        : React.isValidElement(children)
          ? React.cloneElement(children, rest)
          : children
      }
    </div>
  );
}

// import React from "react";

// export default function Item({
//   className,
//   labelClassName,
//   label,
//   children,
//   style,
//   ...rest
// }: any) {
//   const allowedComponents = [
//     "FileUpload",
//     "Input",
//     "Select",
//     "TextArea",
//     "Radio",
//     "Checkbox",
//   ];

//   const modifyChildren = (nodes: any): any => {
//     return React.Children.map(nodes, (child: any) => {
//       if (!React.isValidElement(child)) return child;

//       const elementType =
//         typeof child.type === "string" ? child.type : child.type?.name;

//         console.log({child: React.cloneElement(child, {...rest}), rest})

//       if (allowedComponents.includes(elementType)) {
//         return React.cloneElement(child, {...rest});
//       }

//       // Recursively modify children if needed
//       if ((child.props as any)?.children) {
//         return React.cloneElement(child, ({
//           children: modifyChildren((child.props as any).children),
//         } as any));
//       }

//       return child;
//     });
//   };

//   return (
//     <div className={className} style={style}>
//       {label && <label className={labelClassName}>{label}</label>}
//       {modifyChildren(children)}
//     </div>
//   );
// }
